<template>
<div class="font-D-container non-mobile min-h package-info-wrapper">
	<ul>
		<div class="include_package_speed" v-if="include_package_speed">
            <li>
                {{ download_speed }}
                X
                {{ upload_speed }}
                Mbps
            </li>
        </div>
        <div class="include_package_device_limit" v-if="include_package_device_limit">
        	<div class="device_limit" v-if="device_limit > 0">
                <li>
                    connect up to
                    {{ device_limit }}
                    <div v-if="device_limit > 1">
                    	devices
                    </div>
                    <div v-if="device_limit <= 1">
                    	device
                    </div>
                </li>
            </div>
        </div>

        <li class="non-mobile description">{{ description }}</li>
        <li class="non-mobile radisson_red connectscreen_4.1">Best for: Email, Web browsing</li>
        <li class="non-mobile 14019">&nbsp;</li>
        <li class="non-mobile 14019">Welcome to Canyon Ranch Woodside.</li>
        <li class="non-mobile 14019">&nbsp;</li>
        <li class="non-mobile default">&nbsp;</li>
        <li class="non-mobile default">email</li>
        <li class="non-mobile default">connect to social networks</li>
        <li class="non-mobile default">surf the web</li>
        <li class="non-mobile default">&nbsp;</li>
	</ul>
</div>
</template>

<script>

export default {
  name: "BaseMethodCardInfo"
}

</script>

<style scoped>

</style>